import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-autosave-status',
  standalone: false,
  templateUrl: './autosave-status.html',
  styleUrl: './autosave-status.scss',
})
export class AutosaveStatus {
  @Input() saving = false;
  @Input() label = 'Saving changes';
}
